import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsService } from '../core/services/contact-us.service';

@Component({
  selector: 'app-complaints',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './complaints.component.html',
  styleUrls: ['./complaints.component.css']
})
export class ComplaintsComponent {
  constructor(private contactUsService: ContactUsService) {}

  get contentLabels() { return this.contactUsService.contentLabels; }
}
